export default __webpack_public_path__ + "images/cw-8e4cecbf86c9e4b2df3ae368ef68cdd2.svg";